import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'

import { APP_NAME } from '../../../../static/constants'
import { postDevices } from '../../../../services/api/requests/Device'
// import { DETAILS } from '../../../../services/data/registrationSteps.json'
import { setGACustomPageView } from '../../../../services/analytics/google-analytics'
import ReferralImage from '../../../../assets/img/referral-image.webp'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'

// simplified imports
import { Layout as MainLayout } from '../../../../components/ui/SimplifiedLogin'
import {
  Title,
  Description,
  ContentContainer,
} from '../../../simplified.login/components/MainView/MainView.style'
import RegisterForm from '../RegisterForm/RegisterForm'
import { FormWrapper } from '../../../simplified.register/components/MainView/MainView.style'
import { REGISTRATION_STEPS } from '../../../../services/hooks/useRegistrationBanners'

function MainView(props) {
  const {
    push,
    token,
    setStep,
    replace,
    browser,
    firebase,
    setToken,
    setDevice,
    appleToken,
    googleToken,
    primaryInfo,
    location = {},
    setPrimaryInfo,
    doSavePrimaryInfo,
    doGetFirebaseToken,
    setFirebaseMessagingToken,
    doValidateRegistrationForm,
  } = props

  React.useEffect(() => {
    setGACustomPageView({
      page: location.pathname,
      title: 'Registration - Personal Info',
    })
  }, [location.pathname])

  React.useEffect(() => {
    doGetFirebaseToken({
      firebase,
      setFirebaseMessagingToken,
    })
  }, [doGetFirebaseToken, firebase, setFirebaseMessagingToken])

  React.useEffect(() => {
    if (window.document.cookie.includes('web_uuid=')) {
      return
    }
    const { name, os, version } = browser
    postDevices({
      platform: 'web',
      deviceName: name,
      deviceModel: os,
      osVersion: version,
    }).then(res => {
      setDevice(res.data)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let localSiwaData = null

  if (typeof window !== 'undefined' && window.localStorage) {
    localSiwaData = window.localStorage.getItem('siwaData')
  }

  if (
    localSiwaData &&
    localSiwaData !== undefined &&
    primaryInfo &&
    primaryInfo.appleId !== null
  ) {
    const siwaData = JSON.parse(localSiwaData)

    if (primaryInfo) {
      primaryInfo.firstName = siwaData.name.firstName
      primaryInfo.lastName = siwaData.name.lastName
    }
  }

  const hasThirdPartyToken =
    googleToken || appleToken || (primaryInfo && primaryInfo.appleId)

  const initialValues = {
    ...(primaryInfo || {}),
    ...location.state,
  }

  if (!location.state?.mobileNumber) {
    replace(`/register${location.search}`)
  }

  return (
    <React.Fragment>
      <Helmet>
        <meta
          property="og:title"
          content={`${APP_NAME} | Register Customer Details`}
        />
        <meta property="og:description" content={`What’s cool about you!`} />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_BASE_URL}${ReferralImage}`}
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <MainLayout
        registrationStep={REGISTRATION_STEPS.REGISTER_CUSTOMER_DETAILS}
      >
        <ContentContainer minHeight={800}>
          <div>
            <Title>What’s cool about you!</Title>
            <Description>
              Unlock exciting perks and deals
              <br />
              when you sign up for Zing.
            </Description>
          </div>
          <FormWrapper>
            <AccessibleForm
              enableReinitialize
              validateOnChange={false}
              initialValues={initialValues}
              onSubmit={doSavePrimaryInfo({
                push,
                token,
                setStep,
                setToken,
                googleToken,
                setPrimaryInfo,
                searchString: location.search,
                appleId: primaryInfo ? primaryInfo.appleId || null : null,
              })}
              method="post"
              action="/a/register"
              validate={doValidateRegistrationForm()}
              component={RegisterForm}
              componentProps={{ hasThirdPartyToken }}
            />
          </FormWrapper>
          <div />
        </ContentContainer>
      </MainLayout>
    </React.Fragment>
  )
}

MainView.defaultProps = {
  primaryInfo: null,
  googleToken: null,
  appleId: null,
}

MainView.propTypes = {
  primaryInfo: PropTypes.shape(),
  push: PropTypes.func.isRequired,
  location: PropTypes.shape(),
  googleToken: PropTypes.string,
  setPrimaryInfo: PropTypes.func.isRequired,
  setToken: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  firebase: PropTypes.shape(),
  setFirebaseMessagingToken: PropTypes.func.isRequired,
  doGetFirebaseToken: PropTypes.func.isRequired,
  doSavePrimaryInfo: PropTypes.func.isRequired,
  doValidateRegistrationForm: PropTypes.func.isRequired,
}

export default withRouter(MainView)
